import React, { useState, useEffect, useContext } from 'react';
import { Table, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import Actividad from './Actividad';
import { AuthContext } from '../../../context/authContext';
import matriculacionApiService from '../../../services/http/matriculacionApiService';
import { getItem, STORAGE_KEYS } from '../../../services/storage';
import useSoloLecturaMatriculas from '../../../hooks/useSoloLecturaMatriculas';
import { convocatoriasAgotadas } from '../../../helpers/convocatorias';

const Desplegable = (props) => {
  const [collapse, setCollapse] = useState(false);
  const [isParentChecked, setIsParentChecked] = useState(false);
  const [completed, setIsCompleted] = useState(false);
  const [isWasted, setIsWasted] = useState(false);
  const [activityStateList, setActivityStateList] = useState([]);
  const [convoStateList, setConvoStateList] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(0); // Estado para contar checkboxes seleccionados

  const localEnrollment = getItem(STORAGE_KEYS.ENROLLMENT);
  const { userOU } = useContext(AuthContext);
  const soloLectura = useSoloLecturaMatriculas();

  useEffect(() => {
    let cont = 0;
    let contConv = 0;

    props.activity[props.keyArray].forEach((actividad) => {
      if (actividad.Nota === 1) {
        cont++;
      }

      if (convocatoriasAgotadas(actividad)) {
        contConv++;
      }
    });

    if (cont === props.activity[props.keyArray].length) {
      setIsCompleted(true);
    }
    if (contConv === props.activity[props.keyArray].length) {
      setIsWasted(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataEstadosActividad = await matriculacionApiService.cargarEstadosActividad({
          headquarter: localEnrollment.headquarter,
        });

        const idsToFilter = [0, 1, 2, 3, 5];
        // Estados que las actividades de este modulo ya tienen asignados en BDD
        // (p.ej. Convalidado o Recalificado): aunque no sean seleccionables por
        // defecto, deben aparecer en el select para que se muestre el valor actual.
        const idsEnUso = props.array
          .map((a) => Number(a.idEstado))
          .filter((id) => !Number.isNaN(id));
        const idsPermitidos = [...new Set([...idsToFilter, ...idsEnUso])];
        const filteredData = dataEstadosActividad.filter((item) =>
          idsPermitidos.includes(item.Id),
        );
        setActivityStateList([{ Id: -1, Valor: '' }, ...filteredData]);
      } catch (error) {
        setActivityStateList([]);
      }

      try {
        const dataListaConvocatorias = await matriculacionApiService.cargarListaConvocatorias({
          headquarter: localEnrollment.headquarter,
        });
        setConvoStateList(dataListaConvocatorias);
      } catch (error) {
        setConvoStateList([]);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localEnrollment?.headquarter]);

  useEffect(() => {
    let arrCount = 0;

    props.array.forEach((obj) => {
      const value = `${obj.modulo} ${obj.descripcion}`;

      if (props.modulos.includes(value)) {
        arrCount++;
      }
    });

    setSelectedCheckboxes(arrCount); // Actualiza el contador de checkboxes seleccionados

    if (props.array.length === arrCount) {
      setIsParentChecked(true);
    } else {
      setIsParentChecked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.modulos]);

  const toggle = (e) => {
    if (e.target.id === '') {
      setCollapse(!collapse);
    }
  };

  const handleParentCheckboxChange = () => {
    if (props.markModulosDirty) props.markModulosDirty();
    setIsParentChecked(!isParentChecked);
    let tFinal = 0;
    let tFinalSuelto = 0;
    let tFinal2 = 0;
    let tFinalSuelto2 = 0;
    let hFinal = 0;

    props.array.forEach((obj) => {
      const value = `${obj.modulo} ${obj.descripcion}`;

      if (!isParentChecked) {
        if (!props.modulos.includes(value)) {
          const newArr = props.modulos;
          newArr.push(value);
          props.setModulos([...newArr]);
          if (
            !obj.descripcion.includes('Formación en el centro de trabajo') &&
            !obj.descripcion.includes('Formación en centros de trabajo')
          ) {
            hFinal += parseInt(obj.horas, 10);
          }

          if (obj.curso === 'PRIMERO') {
            tFinal += obj.precio;
            tFinalSuelto += obj.importe_suelto;
          } else {
            tFinal2 += obj.precio;
            tFinalSuelto2 += obj.importe_suelto;
          }
        }
      } else {
        const index = props.modulos.indexOf(value);
        if (index !== -1) {
          const newArr = props.modulos;
          newArr.splice(index, 1);
          props.setModulos([...newArr]);
          if (
            !obj.descripcion.includes('Formación en el centro de trabajo') &&
            !obj.descripcion.includes('Formación en centros de trabajo')
          ) {
            hFinal -= parseInt(obj.horas, 10);
          }
          if (obj.curso === 'PRIMERO') {
            tFinal -= obj.precio;
            tFinalSuelto -= obj.importe_suelto;
          } else {
            tFinal2 -= obj.precio;
            tFinalSuelto2 -= obj.importe_suelto;
          }
        }
      }
    });

    props.setHoursCounter(props.hoursCounter + hFinal);
    props.setTotal(props.total + tFinal);
    props.setTotal2(props.total2 + tFinal2);
    props.setTotalSuelto2(props.totalSuelto2 + tFinalSuelto2);
    props.setTotalSuelto(props.totalSuelto + tFinalSuelto);
  };

  return (
    <div key={props.keyArray}>
      <div
        className="border-bottom rounded-top mb-2 px-2 py-2 pe-auto"
        role="button"
        tabIndex={0}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        }}
        style={{ backgroundColor: '#eef5f9', cursor: 'pointer' }}
      >
        <Row>
          <Col sm="1">
            {props.dataApi.length > 0 ? (
              <input
                type="checkbox"
                checked={isParentChecked}
                onChange={handleParentCheckboxChange}
                id={props.activity[props.keyArray][0].nombre}
                disabled={
                  completed ||
                  isWasted ||
                  props.estado ||
                  props.dataApi[0].estado === 'Revisar secretaria' ||
                  userOU.centro === 'ORIENTACIÓN' ||
                  soloLectura
                }
              />
            ) : (
              ''
            )}
          </Col>
          <Col sm="8">
            <b>
              {props.activity[props.keyArray][0].nombre}
              {completed ? ' - Completado' : ''}{' '}
              {isWasted ? ' - Límite de convocatorias superado' : ''}
            </b>
          </Col>
          <Col sm="1">
            <b>
              {selectedCheckboxes}/{props.activity[props.keyArray].length}
            </b>
          </Col>
          <Col sm="2">
            <b
              style={
                props.activity[props.keyArray][0].curso === 'PRIMERO'
                  ? { color: 'green' }
                  : { color: 'orange' }
              }
            >
              {props.activity[props.keyArray][0].curso === 'PRIMERO' ? 'PRIMER AÑO' : 'SEGUNDO AÑO'}
            </b>
          </Col>
        </Row>
      </div>
      {collapse && (
        <Table responsive borderless>
          <thead>
            <tr>
              <th>Código</th>
              <th>Descripción</th>
              <th>Convocatorias</th>
              <th>Horas</th>
              <th>Precio</th>
              <th>Precio Suelto</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {props.array.map((obj, index) => (
              <Actividad
                // codigo NO es unico: una misma asignatura puede salir en S1 y S2
                // con el mismo codigo. Con keys duplicadas React mezcla las filas y
                // cambiar el estado de una afecta a la otra. El indice garantiza
                // unicidad (el array no se reordena) pase lo que pase con los campos.
                key={`${obj.codigo}-${index}`}
                idMatricula={props.idMatricula}
                obj={obj}
                activityStateList={activityStateList}
                convoStateList={convoStateList}
                hoursCounter={props.hoursCounter}
                setHoursCounter={props.setHoursCounter}
                total={props.total}
                setTotal={props.setTotal}
                total2={props.total2}
                setTotal2={props.setTotal2}
                modulos={props.modulos}
                setModulos={props.setModulos}
                markModulosDirty={props.markModulosDirty}
                estado={props.estado}
                dataApi={props.dataApi}
                setActivity={props.setActivity}
                act={props.activity}
                totalSuelto={props.totalSuelto}
                setTotalSuelto={props.setTotalSuelto}
                totalSuelto2={props.totalSuelto2}
                setTotalSuelto2={props.setTotalSuelto2}
              />
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

Desplegable.propTypes = {
  array: PropTypes.array,
  activity: PropTypes.object,
  keyArray: PropTypes.string,
  modulos: PropTypes.array,
  setModulos: PropTypes.func,
  markModulosDirty: PropTypes.func,
  setHoursCounter: PropTypes.func,
  setTotal: PropTypes.func,
  setTotalSuelto: PropTypes.func,
  totalSuelto: PropTypes.number,
  total: PropTypes.number,
  setTotal2: PropTypes.func,
  setTotalSuelto2: PropTypes.func,
  totalSuelto2: PropTypes.number,
  total2: PropTypes.number,
  hoursCounter: PropTypes.number,
  estado: PropTypes.bool,
  idMatricula: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataApi: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  setActivity: PropTypes.func,
};

export default Desplegable;
